import { styled } from "@mui/material";

export default styled("div")`

    padding: .5em 0;

   .title {
        font-weight: 700;
        font-size: 16px;
        line-height: 19.2px;
        letter-spacing: 0px;
        padding: 10px;
    }

    .horizontal-list {
        display: flex;
        flex-direction: row;
        padding: 0 0 0 10px;
        cursor: grab;

        .swiper-pagination  {
            display: none;
        }

        .swiper-slide {
            width: 110px !important;
            margin-right: 0 !important;
        }
    }

    .horizontal-box {
        width: 100px;
        height: auto;
        display: flex;
        overflow: hidden;
        flex-direction: column;
        margin: 0;

        img {
            width: 100%;
            height: 150px;
            border-radius: 20px;
            background-color: #888;
        }

        .text {
            margin-top: 10px;
            padding: 0 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .name {
                font-size: 14px;
                font-weight: 500;
                text-align: center;
                line-height: 19.2px;
                letter-spacing: 0px;
            }

            .length {
                font-weight: 400;
                font-size: 12px;
                line-height: 18px;
                letter-spacing: 0%;
                text-align: center;
                color: #888;
            }
        }
    }

`;
